// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_gV","advertCardHeader__actions":"c-a_gW","advertCardHeader__bottomLabel":"c-a_gX"};